const Spinner = () => {
return (
// w-[60px] in brackets apni mrzi ki value use krsktay hai yai auto class create krdeta ha tailwind css mai
<div className="inline-block w-[60px] h-[60px] rounded-full border-[5px]
border-t-black/100 border-r-black/100 animate-spin"> 

</div>
)}

export default Spinner;